import axios from 'axios'

/** Noise for the Novartshop platform log only — Sentry still receives API errors. */
export function isIgnorableClientError(error: unknown): boolean {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status
    if (!status || status < 500) return true
  }

  const message = error instanceof Error
    ? error.message
    : typeof error === 'string'
      ? error
      : ''

  if (/Request failed with status code [1-4]\d\d/.test(message)) return true
  if (/ResizeObserver loop/i.test(message)) return true
  return false
}
